export const LOADING = "LOADING";
export const LOAD_USER_PROFILE = "LOAD_USER_PROFILE";
export const PERFORM_LOGOUT = "PERFORM_LOGOUT";

export const ACCOUNT_FORM_FIELD_CHANGE = "ACCOUNT_FORM_FIELD_CHANGE";
export const STATS_UPDATED = "STATS_UPDATED";
export const ADMIN_SET_ELO_SUCCESS = "ADMIN_SET_ELO_SUCCESS";

export const ACCOUNT_UPDATE_DURING = "ACCOUNT_UPDATE_DURING";
export const ACCOUNT_UPDATE_ALERT = "ACCOUNT_UPDATE_ALERT";
export const ACCOUNT_UPDATE_ALERT_SNOOZE = "ACCOUNT_UPDATE_ALERT_SNOOZE";
export const ACCOUNT_UPDATE_COMPLETE = "ACCOUNT_UPDATE_COMPLETE";
export const ACCOUNT_SUCCESS_ALERT_SNOOZE = "ACCOUNT_SUCCESS_ALERT_SNOOZE";

export const ADMIN_LOAD_USERS = "ADMIN_LOAD_USERS";
export const ADMIN_SET_PLAYER_STATS_SUCCESS = "ADMIN_SET_PLAYER_STATS_SUCCESS";

export const ADMIN_LOAD_REPORTED_PLAYERS = "ADMIN_LOAD_REPORTED_PLAYERS";

export const ADMIN_SET_TARGET_USER_CONTEXT = "ADMIN_SET_TARGET_USER_CONTEXT";
export const ADMIN_SET_PLAYER_TRACKER_STATS_DIALOG_STATE =
  "ADMIN_SET_PLAYER_TRACKER_STATS_DIALOG_STATE";
export const ADMIN_SET_ELO_DIALOG_STATE = "ADMIN_SET_ELO_DIALOG_STATE";
export const ADMIN_SET_PLAYER_VERIFIED_DIALOG_STATE =
  "ADMIN_SET_PLAYER_VERIFIED_DIALOG_STATE";

export const ADMIN_SET_PLAYER_AS_VERIFIED_SUCCESS =
  "ADMIN_SET_PLAYER_AS_VERIFIED_SUCCESS";

export const ADMIN_SET_PLAYER_REJECTED_DIALOG_STATE =
  "ADMIN_SET_PLAYER_REJECTED_DIALOG_STATE";

export const ADMIN_SET_PLAYER_AS_REJECTED_SUCCESS =
  "ADMIN_SET_PLAYER_AS_REJECTED_SUCCESS";

export const ADMIN_SET_PLAYER_NOT_ELIGIBLE_DIALOG_STATE =
  "ADMIN_SET_PLAYER_NOT_ELIGIBLE_DIALOG_STATE";
export const ADMIN_SET_PLAYER_AS_NOT_ELIGIBLE_SUCCESS =
  "ADMIN_SET_PLAYER_AS_NOT_ELIGIBLE_SUCCESS";

export const ADMIN_SET_PLAYER_BANNED_DIALOG_STATE =
  "ADMIN_SET_PLAYER_BANNED_DIALOG_STATE";

export const ADMIN_SET_PLAYER_BANNED_SUCCESS =
  "ADMIN_SET_PLAYER_BANNED_SUCCESS";

export const SET_ONLINE_USER_COUNT = "SET_ONLINE_USER_COUNT";
export const SET_TOTAL_PLAYERS_IN_QUEUE = "SET_TOTAL_PLAYERS_IN_QUEUE";
export const SET_TOTAL_LOBBIES = "SET_TOTAL_LOBBIES";
export const SET_QUEUE_ANALITYCS_SUMMARY = "SET_QUEUE_ANALITYCS_SUMMARY";
export const SET_MM_ACTIVITY_SUMMARY = "SET_MM_ACTIVITY_SUMMARY";
export const SET_NEWEST_PLAYERS = "SET_NEWEST_PLAYERS";
export const SET_WEEKLY_DATA_FOR_CHART = "SET_WEEKLY_DATA_FOR_CHART";
export const SET_SEVEN_DAYS_MATCHMAKING_DATA_FOR_CHART = "SET_SEVEN_DAYS_MATCHMAKING_DATA_FOR_CHART";
export const SET_THIRTY_DAYS_MATCHMAKING_DATA_FOR_CHART = "SET_THIRTY_DAYS_MATCHMAKING_DATA_FOR_CHART";
export const SET_NINETY_DAYS_MATCHMAKING_DATA_FOR_CHART = "SET_NINETY_DAYS_MATCHMAKING_DATA_FOR_CHART";
export const SET_MONTHLY_DATA_FOR_CHART = "SET_MONTHLY_DATA_FOR_CHART";
export const SET_YEARLY_DATA_FOR_CHART = "SET_YEARLY_DATA_FOR_CHART";
export const SET_MATCH_DURATION_DATA = "SET_MATCH_DURATION_DATA";
export const SET_SEVEN_DAYS_QUEUE_DATA_FOR_CHART = "SET_SEVEN_DAYS_QUEUE_DATA_FOR_CHART";
export const SET_THIRTY_DAYS_QUEUE_DATA_FOR_CHART = "SET_THIRTY_DAYS_QUEUE_DATA_FOR_CHART";
export const SET_NINETY_DAYS_QUEUE_DATA_FOR_CHART = "SET_NINETY_DAYS_QUEUE_DATA_FOR_CHART";
export const SET_PLAYERS_QUEUED_PER_DAY_DATA = "SET_PLAYERS_QUEUED_PER_DAY_DATA";
export const SET_QUEUE_EFFICIENCY_PER_DAY_DATA = "SET_QUEUE_EFFICIENCY_PER_DAY_DATA";
export const SET_QUEUE_OUTCOME_DISTRIBUTION_DATA = "SET_QUEUE_OUTCOME_DISTRIBUTION_DATA";
export const SET_MATCHMAKING_CAPACITY_TREND_DATA = "SET_MATCHMAKING_CAPACITY_TREND_DATA";
export const SET_SERVERS_ALIVE_COUNT = "SET_SERVERS_ALIVE_COUNT";